import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from '../../services/session';
import Loc from '../../services/localization';

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            fromDate: '',
            toDate: '',
            loading: false,
            loaded: false,
            reportGroups: []
        }
    },
    computed: {
        canSeeReport() {
            return this.role === 'ROLE_SUPER_ADMIN';
        },
        flatInvoices() {
            var groups = this.reportGroups || [];
            var all = [];

            for (var i = 0; i < groups.length; i++) {
                var group = groups[i] || {};
                var companyName = group.company || '/';
                var invoices = group.invoices || [];

                for (var j = 0; j < invoices.length; j++) {
                    var item = invoices[j] || {};
                    all.push({
                        id: item.id,
                        company: companyName,
                        isPaid: item.isPaid === true,
                        createdTime: item.createdTime,
                        fromPeriod: item.fromPeriod,
                        toPeriod: item.toPeriod,
                        amount: this.getInvoiceAmount(item),
                        invoiceItems: item.invoiceItems
                    });
                }
            }

            return all;
        },
        totalTurnover() {
            var rows = this.flatInvoices;
            var total = 0;

            for (var i = 0; i < rows.length; i++) {
                total += toNumber(rows[i].amount);
            }

            return total;
        },
        totalInvoices() {
            return this.flatInvoices.length;
        },
        debtorsList() {
            var rows = (this.flatInvoices || []).filter(function (row) {
                return row.isPaid !== true;
            });

            rows.sort(function (a, b) {
                return toNumber(b.amount) - toNumber(a.amount);
            });

            return rows;
        },
        companyChartData() {
            var map = {};
            var rows = this.flatInvoices || [];

            for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                var key = row.company || '/';
                map[key] = toNumber(map[key]) + toNumber(row.amount);
            }

            var list = [];
            for (var name in map) {
                if (Object.prototype.hasOwnProperty.call(map, name)) {
                    list.push({
                        label: name,
                        value: toNumber(map[name])
                    });
                }
            }

            list.sort(function (a, b) {
                return b.value - a.value;
            });

            return list;
        },
        monthlyChartData() {
            var map = {};
            var rows = this.flatInvoices || [];

            for (var i = 0; i < rows.length; i++) {
                var row = rows[i] || {};
                var dateValue = row.createdTime != null ? row.createdTime : row.toPeriod;
                var parsed = parseDateInput(dateValue);

                if (parsed == null) {
                    continue;
                }

                var monthKey = this.$moment(parsed).format('YYYY-MM');
                map[monthKey] = toNumber(map[monthKey]) + toNumber(row.amount);
            }

            var list = [];
            for (var key in map) {
                if (Object.prototype.hasOwnProperty.call(map, key)) {
                    var date = this.$moment(key + '-01', 'YYYY-MM-DD').toDate();
                    list.push({
                        key: key,
                        label: this.$moment(date).format('MM-YYYY'),
                        value: toNumber(map[key])
                    });
                }
            }

            list.sort(function (a, b) {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });

            return list;
        },
        maxCompanyValue() {
            return getMax(this.companyChartData);
        },
        maxMonthlyValue() {
            return getMax(this.monthlyChartData);
        }
    },
    methods: {
        clickSearch: clickSearch,
        chartWidth: chartWidth,
        formatMoney: formatMoney,
        formatDate: formatDate,
        shortLabel: shortLabel,
        getInvoiceAmount: getInvoiceAmount,
        openInvoices: openInvoices,
        canSearch: canSearch
    },
    beforeMount() {
        if (session.getAccessToken() == null || session.getAccessToken() === '') {
            this.$router.push('/login');
            return;
        }

        this.role = session.getRole();

        if (!this.canSeeReport) {
            return;
        }

        var today = new Date();
        var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

        this.fromDate = this.$moment(firstDay).format('YYYY-MM-DD');
        this.toDate = this.$moment(today).format('YYYY-MM-DD');

        this.clickSearch();
    }
}

function canSearch() {
    return this.fromDate != null && this.fromDate.length > 0 && this.toDate != null && this.toDate.length > 0;
}

function openInvoices() {
    this.$router.push('/invoices');
}

function clickSearch() {
    var _self = this;

    if (!this.canSearch()) {
        return;
    }

    var from = this.$moment(this.fromDate).format('DD-MM-YYYY');
    var to = this.$moment(this.toDate).format('DD-MM-YYYY');

    this.loading = true;
    this.loaded = false;

    AdminApiService.getMinusInvoiceReport(from, to)
        .then(function (response) {
            _self.reportGroups = response.data || [];
            _self.loading = false;
            _self.loaded = true;
        })
        .catch(function (error) {
            _self.loading = false;
            _self.loaded = false;
            swal(LocService.t('label_error'), resolveErrorMessage(error), 'error');
        })
}

function getInvoiceAmount(item) {
    if (item == null) return 0;

    if (item.displayAmount != null) return Math.abs(toNumber(item.displayAmount));
    if (item.amountWithDiscount != null) return Math.abs(toNumber(item.amountWithDiscount));
    if (item.amount != null) return Math.abs(toNumber(item.amount));

    return 0;
}

function formatMoney(value) {
    var amount = Math.abs(toNumber(value));
    return amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

function formatDate(value) {
    var parsed = parseDateInput(value);
    if (parsed == null) return '/';

    return this.$moment(parsed).format('DD-MM-YYYY');
}

function shortLabel(text, max) {
    if (text == null) return '/';
    var normalized = String(text);

    if (normalized.length <= max) return normalized;
    return normalized.slice(0, max - 1) + '…';
}

function chartWidth(value, max) {
    var n = toNumber(value);
    var m = toNumber(max);

    if (m <= 0 || n <= 0) return '0%';

    var pct = (n / m) * 100;
    if (pct < 4) pct = 4;
    if (pct > 100) pct = 100;

    return pct + '%';
}

function parseDateInput(value) {
    if (value == null || value === '') return null;

    if (typeof value === 'number') {
        var asMs = value > 9999999999 ? value : value * 1000;
        var dateFromNumber = new Date(asMs);
        if (isNaN(dateFromNumber.getTime())) return null;
        return dateFromNumber;
    }

    if (typeof value === 'string') {
        var trimmed = value.trim();
        if (trimmed.length === 0) return null;

        if (/^[0-9]+$/.test(trimmed)) {
            var asInt = parseInt(trimmed, 10);
            var asIntMs = asInt > 9999999999 ? asInt : asInt * 1000;
            var dateFromInt = new Date(asIntMs);
            if (!isNaN(dateFromInt.getTime())) return dateFromInt;
        }

        var dateFromString = new Date(trimmed);
        if (!isNaN(dateFromString.getTime())) return dateFromString;
    }

    return null;
}

function toNumber(value) {
    if (value == null || value === '') return 0;
    var parsed = Number(value);
    if (isNaN(parsed)) return 0;
    return parsed;
}

function getMax(list) {
    var max = 0;

    for (var i = 0; i < (list || []).length; i++) {
        var current = toNumber(list[i].value);
        if (current > max) {
            max = current;
        }
    }

    return max;
}

function resolveErrorMessage(error) {
    if (error == null) return '';

    if (error.data != null && error.data.localized_error_message != null) {
        return error.data.localized_error_message;
    }

    if (error.response != null && error.response.status === 403) {
        return LocService.t('label_no_permission_for_report');
    }

    if (error.response != null && error.response.data != null) {
        if (error.response.data.localized_error_message != null) {
            return error.response.data.localized_error_message;
        }
        if (error.response.data.message != null) {
            return error.response.data.message;
        }
    }

    return LocService.t('label_error');
}



// WEBPACK FOOTER //
// ./src/components/Invoice/InvoiceReport.js